import React from 'react';
import { Box, Typography, List, ListItem, ListItemText, Button, Stack } from '@mui/material';
import { UploadFileOutlined } from '@mui/icons-material';
import type { StepFile } from '@/types/run-stage.types';

interface UploadsPanelProps {
  files: StepFile[];
  isReadOnly?: boolean;
  onUpload?: () => void;
}

export const UploadsPanel: React.FC<UploadsPanelProps> = ({ files, isReadOnly, onUpload }) => {
  return (
    <Box sx={{ p: 1.5 }}>
      <Stack direction="row" sx={{ alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
          Uploads ({files.length})
        </Typography>
        {!isReadOnly && (
          <Button
            size="small"
            startIcon={<UploadFileOutlined />}
            onClick={onUpload}
            sx={{ textTransform: 'none' }}
          >
            Upload
          </Button>
        )}
      </Stack>
      {files.length > 0 ? (
        <List dense disablePadding>
          {files.map((f, i) => (
            <ListItem key={f._id || i} disablePadding sx={{ py: 0.25 }}>
              <ListItemText
                primary={f.name || `File ${i + 1}`}
                secondary={f.uploadedAt ? new Date(f.uploadedAt).toLocaleString() : undefined}
                slotProps={{
                  primary: { variant: 'body2', color: 'primary', sx: { cursor: 'pointer' } },
                  secondary: { variant: 'caption' },
                }}
              />
            </ListItem>
          ))}
        </List>
      ) : (
        <Typography variant="body2" color="text.secondary">No files uploaded.</Typography>
      )}
    </Box>
  );
};
